import { useActiveUnit } from "components/Unit";
import { atom, useAtom } from "jotai";
import { useEffect } from "react";

const isOpenHouseDrawer = atom(false);
const OpenHouseDrawerUnit = atom(null);

const useOpenHouseDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(isOpenHouseDrawer);
  const [unit, setUnit] = useAtom(OpenHouseDrawerUnit);
  const activeUnit = useActiveUnit();

  const toggle = () => {
    if (isOpen) {
      // set null if closed.
      setUnit(null);
    }

    setIsOpen(!isOpen);
  };

  const open = (unit) => {
    setUnit(unit);
    setIsOpen(true);
  };
  const close = () => {
  setIsOpen(false);
  setUnit(null);
};

useEffect(()=> {
  
  if(activeUnit) {
    setUnit(activeUnit);
  }
 
}, [activeUnit?.getId()])


  return { toggle, open, isOpen, unit,close };
};

export { useOpenHouseDrawer };
